import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';

export type CurrentLocationValue = {
  latitude: number | null;
  longitude: number | null;
  label: string | null;
};

const currentLocationKey = ['current-location'];

export const useCurrentLocation = () => {
  return useQuery({
    queryKey: currentLocationKey,
    queryFn: async () => {
      const response = await axios.post<CurrentLocationValue>(
        config.apiGateway.currentLocation
      );
      return response.data;
    },
  });
};

export const useUpdateCurrentLocation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (value: CurrentLocationValue) => {
      const response = await axios.post(
        config.apiGateway.updateCurrentLocation,
        value
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: currentLocationKey });
    },
  });
};
